import { render } from "./daytwo.vue?vue&type=template&id=a4e7eea0"
import script from "./daytwo.vue?vue&type=script&lang=js"
export * from "./daytwo.vue?vue&type=script&lang=js"

import "./daytwo.vue?vue&type=style&index=0&id=a4e7eea0&lang=scss"
script.render = render

export default script